// src/components/GoogleSignInButton.jsx
import { useEffect, useRef } from 'react';
import { jwtDecode } from 'jwt-decode';  // ← Fixed import

const GoogleSignInButton = ({ onSuccess, onError }) => {
  const googleButtonRef = useRef(null);

  const handleCredentialResponse = (response) => {
    const idToken = response.credential;
    
    console.log('=== Google Sign-In Success ===');
    console.log('ID Token:', idToken);

    try {
      const decoded = jwtDecode(idToken);  // ← Fixed function name (camelCase)
      console.log('Decoded User Details:', decoded);
      
      console.log('Name:', decoded.name);
      console.log('Email:', decoded.email);
      console.log('Picture URL:', decoded.picture);
      console.log('Google ID (sub):', decoded.sub);
      console.log('Token expires at:', new Date(decoded.exp * 1000));

      if (onSuccess) {
        onSuccess({ token: idToken, user: decoded });
      }
    } catch (err) {
      console.error('Error decoding token:', err);
      if (onError) onError(err);
    }
  };

  
  useEffect(() => {
    // Load Google Identity Services script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id: '24694079816-3ed0hie7ctc0dci77efb4nartvip5505.apps.googleusercontent.com', // ⚠️ Palitan mo ito!
        callback: handleCredentialResponse,
      });

      window.google.accounts.id.renderButton(
        googleButtonRef.current,
        {
          theme: 'outline',
          size: 'large',
          type: 'standard',
          text: 'signin_with',
          shape: 'rectangular',
          logo_alignment: 'left',
        }
      );

      // Optional: One Tap prompt (pwede i-comment out kung ayaw)
      // window.google.accounts.id.prompt();
    };

    script.onerror = () => {
      console.error('Failed to load Google Identity Services script');
      if (onError) onError(new Error('Script load failed'));
    };

    // Cleanup
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [onError]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
      <div ref={googleButtonRef} />
    </div>
  );
};

export default GoogleSignInButton;